/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../Constants", "../FluxCommon/ActionsHubManager", "../FluxCommon/Store", "../Pods/PodsActions", "./ServicesActions"], function (require, exports, Constants_1, ActionsHubManager_1, Store_1, PodsActions_1, ServicesActions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ServicesStore = /** @class */ (function (_super) {
        __extends(ServicesStore, _super);
        function ServicesStore() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._servicesFetched = function (serviceList) {
                _this._state.serviceList = serviceList;
                _this._state.isLoading = false;
                _this.emit(Constants_1.ServicesEvents.ServicesFetchedEvent, _this);
                if (_this._state.serviceList && _this._state.serviceList.items && _this._state.serviceList.items.length > 0) {
                    _this.emit(Constants_1.ServicesEvents.ServicesFoundEvent, _this);
                }
            };
            _this._setAssociatedPodsList = function (payload) {
                _this._state.podsList = payload.podsList && payload.podsList.items;
                _this._state.arePodsLoading = payload.isLoading;
                _this.emit(Constants_1.ServicesEvents.ServicePodsFetchedEvent, _this);
            };
            return _this;
        }
        ServicesStore.getKey = function () {
            return "services-store";
        };
        ServicesStore.prototype.initialize = function (instanceId) {
            _super.prototype.initialize.call(this, instanceId);
            this._state = { serviceList: undefined, podsList: [], isLoading: true, arePodsLoading: true };
            this._servicesActions = ActionsHubManager_1.ActionsHubManager.GetActionsHub(ServicesActions_1.ServicesActions);
            this._podsActions = ActionsHubManager_1.ActionsHubManager.GetActionsHub(PodsActions_1.PodsActions);
            this._servicesActions.servicesFetched.addListener(this._servicesFetched);
            this._podsActions.podsFetchedByLabel.addListener(this._setAssociatedPodsList);
        };
        ServicesStore.prototype.disposeInternal = function () {
            this._servicesActions.servicesFetched.removeListener(this._servicesFetched);
            this._podsActions.podsFetchedByLabel.removeListener(this._setAssociatedPodsList);
        };
        ServicesStore.prototype.getState = function () {
            return this._state;
        };
        ServicesStore.prototype.getServicesSize = function () {
            return this._state.serviceList && this._state.serviceList.items ? this._state.serviceList.items.length : 0;
        };
        return ServicesStore;
    }(Store_1.StoreBase));
    exports.ServicesStore = ServicesStore;
});
